module.exports = __webpack_public_path__ + "static/media/AD_AC.2f553414.png";